import { useForm } from "@/src/provider/Form/FormProvider";
import Grid from "@mui/material/Grid";
import ValidatorSelectField from "@/src/components/FormFields/ValidatorSelectField";
import MenuItem from "@mui/material/MenuItem";
import EmailCheck from "@/src/components/EmailCheck/EmailCheck";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import ButtonLoading from "@/src/components/Button/ButtonLoading";
import ButtonTextTermsOfServicePrivacy from "@/src/components/Checkin/Common/ButtonTextTermsOfServicePrivacy/ButtonTextTermsOfServicePrivacy";
import React from "react";
import { emailDefault, isPhoneNumberDefault, minStringLength, requiredValidator } from "@/src/services/validationRules";
import divorceCheckinStyle from "./divorceCheckinStyle";

type DivorceCheckinFormProps = {
  isLoading: boolean;
  emailErrorText: string;
  setEmailErrorText: (emailErrorText: string) => void;
};

export default function DivorceCheckinForm({ isLoading, emailErrorText, setEmailErrorText }: DivorceCheckinFormProps) {
  const { handleSubmit } = useForm();
  return (
    <form onSubmit={handleSubmit}>
      <Grid
        container
        sx={{
          alignItems: "baseline",
          justifyContent: "center"
        }}>
        <Grid
          sx={divorceCheckinStyle.gridSpaceMd}
          size={{
            xs: 12,
            md: 4
          }}>
          <ValidatorSelectField
            label="Wie lange leben Sie getrennt?"
            name="classification"
            validators={[requiredValidator("Bitte geben Sie an wie lange Sie getrennt sind")]}
          >
            <MenuItem value={"easy"}>Länger als 10 Monate</MenuItem>
            <MenuItem value={"medium"}>Kürzer als 10 Monate</MenuItem>
            <MenuItem value={"hard"}>Noch nicht getrennt lebend</MenuItem>
          </ValidatorSelectField>
        </Grid>
        <Grid
          sx={divorceCheckinStyle.gridSpace}
          size={{
            xs: 12,
            sm: 6,
            md: 4
          }}>
          <EmailCheck
            name="email"
            label="Ihre E-Mail-Adresse"
            autoComplete="email"
            emailErrorText={emailErrorText}
            setEmailErrorText={setEmailErrorText}
            validators={[requiredValidator("Bitte geben Sie Ihre E-Mail-Adresse an"), emailDefault]}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 4
          }}>
          <ValidatorTextField
            name="telephone"
            label="Ihre Telefonnummer"
            autoComplete="tel"
            validators={[requiredValidator("Bitte geben Sie Ihre Telefonnummer an"), ...isPhoneNumberDefault]}
          />
        </Grid>
        <Grid
          sx={divorceCheckinStyle.gridSpaceMd}
          size={{
            xs: 12,
            md: 4
          }}>
          <ValidatorSelectField displayEmpty label="Anrede" name={`gender`} autoComplete="sex">
            <MenuItem value={""}>Keine Anrede</MenuItem>
            <MenuItem value={"female"}>Frau</MenuItem>
            <MenuItem value={"male"}>Herr</MenuItem>
          </ValidatorSelectField>
        </Grid>
        <Grid
          sx={divorceCheckinStyle.gridSpace}
          size={{
            xs: 12,
            sm: 6,
            md: 4
          }}>
          <ValidatorTextField
            name={`givenName`}
            label="Vorname"
            autoComplete="given-name"
            validators={[
              requiredValidator("Bitte geben Sie den Vornamen an"),
              { validator: minStringLength, params: [2], message: "Bitte kontrollieren Sie Ihre Eingabe" },
            ]}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 4
          }}>
          <ValidatorTextField
            name={`familyName`}
            label="Nachname"
            autoComplete="family-name"
            validators={[
              requiredValidator("Bitte geben Sie den Nachnamen an"),
              { validator: minStringLength, params: [2], message: "Bitte kontrollieren Sie Ihre Eingabe" },
            ]}
          />
        </Grid>
        <Grid
          sx={[divorceCheckinStyle.submit, divorceCheckinStyle.gridTopSpaced]}
          size={{
            xs: 12,
            sm: 6
          }}>
          <ButtonLoading variant="contained" color="primary" sx={divorceCheckinStyle.button} type="submit" fullWidth isLoading={isLoading}>
            Jetzt kostenlos starten
          </ButtonLoading>
          <ButtonTextTermsOfServicePrivacy />
        </Grid>
      </Grid>
    </form>
  );
}
